const toasts = reactive([]);

function addToast({ message, type = "default", duration = 10000 }) {
  const id = Date.now() + Math.random();
  toasts.push({ id, message, type });
  setTimeout(() => removeToast(id), duration);
}

function removeToast(id) {
  const idx = toasts.findIndex((t) => t.id === id);
  if (idx !== -1) toasts.splice(idx, 1);
}

export function useToast() {
  return { toasts, addToast, removeToast };
}
